import {_ReactPixi, applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {
    TextInput,
    TextInputStyle,
    TextInputBox
} from '@gongxigames/framework/core/fragments/display';
import {Container} from 'pixi.js';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {IBrowser} from '@gongxigames/framework/core/types';
import {inversifyContainer} from '@gongxigames/framework/core/installer';

type InputTextInteractionEvents = {
    input?: (text: string) => void;
    keydown?: (keycode: number) => void;
    keyup?: (keycode: number) => void;
    focus?: () => void;
    blur?: () => void;
};

type InputTextInteractionEventsTypes = keyof InputTextInteractionEvents;

type TextInputOptions = {
    textStyle: TextInputStyle;
    boxStyle?: TextInputBox;
    disabledPasteFromClipboard?: boolean;
    text?: string;
} & InputTextInteractionEvents;

export type TextInputProps = _ReactPixi.Container<Container, TextInputOptions> & {
    placeholder?: string;
    restrict?: RegExp;
};

function getProps(textProps: TextInputProps): Omit<TextInputProps, 'boxStyle' | 'textStyle' | 'disabledPasteFromClipboard'> {
    const {
        input,
        keydown,
        keyup,
        focus,
        blur,
        textStyle,
        boxStyle,
        disabledPasteFromClipboard,
        ...props
    } = textProps;

    return props;
}

const INPUT_TEXT_INTERACTION_EVENTS: InputTextInteractionEventsTypes[] = ['input', 'focus', 'blur', 'keydown', 'keyup'];
let browser: IBrowser;

export const TextInputComponent = PixiComponent<TextInputProps, TextInput>('TextInputComponent', {
    create(props: TextInputProps): TextInput {
        // eslint-disable-next-line no-useless-catch
        try {
            const textInputOptions = {
                box: props.boxStyle,
                input: props.textStyle,
                disabledPasteFromClipboard: props.disabledPasteFromClipboard
            };

            browser ||= inversifyContainer.get<IBrowser>(CoreDI.Browser);

            return new TextInput(textInputOptions, browser);
        } catch (e) {
            throw e;
        }
    },
    applyProps(instance: TextInput, oldProps: TextInputProps, newProps: TextInputProps): void {
        const oldP = getProps(oldProps);
        const newP = getProps(newProps);

        INPUT_TEXT_INTERACTION_EVENTS.forEach(event => {
            if (newProps[event] || oldProps[event]) {
                instance.removeAllListeners(event);

                if (newProps[event]) {
                    instance.on(event, newProps[event] as any);
                }
            }
        });

        applyDefaultProps(instance, oldP, newP);

        if (oldProps.boxStyle || newProps.boxStyle) {
            instance.setBoxStyle(newProps.boxStyle);
        }
    }
});
